import React, { Component } from 'react';
import CoursesScreen from './CoursesScreen'


function CoursesMainScreen() {

  return (
    <div>


      <CoursesScreen />


    </div>
  );

}

export default CoursesMainScreen;